(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('logBuffer', logBuffer);

	function logBuffer(_, assetCommonConfig) {
		var bufferSize = assetCommonConfig.logBufferSize;
		var logs = [];

		return {
			getRecentLogs: function () {
				return logs;
			},
			addLog: function (level, data) {
				if (level === 'debug')
					return;

				var obj = {};
				obj[level] = _.isArray(data) ? data[0] : data;

				logs.push(obj);

				if (logs.length > bufferSize)
					logs.splice(-bufferSize, logs.length - bufferSize);
			}
		};
	}
	logBuffer.$inject = ['_', 'assetCommonConfig'];
})();